import {Brand, MarketingReviews} from "@/marketingPages/components/marketingreviews/MarketingReviews.tsx";

export const IsItDownReviews = () => {
  const items = [
    {
      brand: Brand.G2,
      name: "Derek W.",
      role: "Information Technology Analyst, Uptime User",
      review:
        "The intuitive interface and customizable dashboards allow me to quickly access relevant information and take action in case of any issues.",
    },
    {
      brand: Brand.SourceForge,
      name: "Dave S.",
      role: "Lead Developer, Uptime User",
      review: "Extremely easy to set up and use, with a very intuitive and well-thought-out interface.",
    },
    {
      brand: Brand.G2,
      name: "Uptime.com User",
      role: "Platform Engineer",
      review: "We were up and running with transactional checks monitoring our public portals within minutes.",
    },
  ];
  return <MarketingReviews items={items} />;
};
